import React, { useState, useEffect, useRef } from "react";
import { FaTrashAlt , FaEnvelope} from "react-icons/fa";
import "./Utilisateurs.css";
import { Toast } from 'primereact/toast';
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import AddUser from "./popup/AddUSer";
import DeleteUser from "./popup/DeleteUser";
import { Column } from "primereact/column";
import { useClient } from "../../../../Context/ClientContext";
import { useQuery } from 'react-query';
import { useUser } from "../../../../Context/UserContext";
import { getUsersByClient } from "../../../../Data/user_service";
import { isGexMemeber } from "../../navBar";
import { instance } from "../../../../api";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import moment from "moment";





export default function Utilisateurs() {
  const {setUserList , users , setSelectedUser , user }=useUser()
  const [isAdmin, setIsAdmin] = useState(false);
  const [isMember, setIsMember] = useState(false);
  const [confirmResetOpen, setConfirmResetOpen] = useState(false);
  const [targetUser, setTargetUser] = useState(null);
  const [sendingReset, setSendingReset] = useState(false)
 const [deletingUser, setDeletingUser] = useState(false);

  // const [isMounted, setIsMounted] = useState(false);
  const [openDialogAdd, setDialogAdd] = useState(false);
  const [openDialogDelete, setDialogDelete] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [searchText, setSearchText] = useState(""); // Add state for search text
  const [filteredUsers, setFilteredUsers] = useState([]); // Filtered users list
  // const [isMounted, setIsMounted] = useState(false);
  const toast = useRef(null);
  const {client , selectedClient}=useClient()
  
  // Fetch users based on selected client
// const {user} = useUser();
const clientTableau = Object.values(client);


const checkAdminRole = () => {
  if (!selectedClient || !clientTableau.length) {
    setIsAdmin(false);
    setIsMember(false);
    return;
  }
// Find the selected client's roles
  const clientData = clientTableau.find(
    (client) => client.id_client_gexpertise === selectedClient
  );

  if (clientData && clientData.role && clientData.role.toLowerCase() === "utilisateur") {
    setIsAdmin(true);
  } else {
    setIsAdmin(false);
  }
  setIsMember(isGexMemeber(user));

};

useEffect(() => {
  checkAdminRole();
}, [selectedClient, clientTableau]);
useEffect(() => {
  console.log("ClientTableau:", clientTableau);
  console.log("SelectedClient:", selectedClient);
  console.log("Is Admin?", isAdmin);
  console.log("Is GexMember?", isMember);

}, [isAdmin, isMember,selectedClient, clientTableau]);

// Build a map from /api/utilisateurs/ that contains last-connexion per user
const fetchLastConnexionMap = async () => {
  // This endpoint is used by your second screen and DOES include last connexion
  const { data } = await instance.get('/api/utilisateurs/');
  // Create a map by email (fallback to id if you prefer)
  const map = new Map();
  for (const u of Array.isArray(data) ? data : []) {
    const key = (u.email || u.id_utilisateur_gexonline || '').toString().toLowerCase();
    if (!key) continue;
    // adapt the source field name if different in this endpoint
    const last = u.ladate_de_derniere_connexion
      ?? u.lastSeenConnexion
      ?? null;
    map.set(key, last);
  }
  return map;
};

// Merge last-connexion values into your current usersList
const enrichUsersWithLastConnexion = (list, lastMap) => {
  return (list || []).map(u => {
    const key = (u.email || u.id_utilisateur_gexonline || '').toString().toLowerCase();
    const last = lastMap.get(key) ?? u.ladate_de_derniere_connexion ?? null;
    return { ...u, ladate_de_derniere_connexion: last };
  });
};

// Scanne l'objet pour trouver un champ "dernière connexion"
const pickLastLoginRaw = (u) => {
  if (!u || typeof u !== "object") return null;

  // 1) Noms les plus probables (ordre de priorité)
  const candidates = [
    "ladate_de_derniere_connexion",
  ];

  for (const k of candidates) {
    if (u[k] != null && u[k] !== "") return u[k];
  }

  // 2) Fallback: cherche un champ qui matche /connexion/i ou /login/i
  const dynamic = Object.keys(u).find(
    (k) => /connexion|connect|login|access/i.test(k) && u[k] != null && u[k] !== ""
  );
  return dynamic ? u[dynamic] : null;
};
useEffect(() => {
  let cancelled = false;

  // Only try to enrich if we have rows and we're missing the field
  const needsEnrich = usersList?.some(u => u.ladate_de_derniere_connexion == null);
  if (!usersList?.length || !needsEnrich) return;

  (async () => {
    try {
      const lastMap = await fetchLastConnexionMap();
      if (cancelled) return;
      const merged = enrichUsersWithLastConnexion(usersList, lastMap);
      setUsersList(merged);
      // Keep your filtered list in sync too
      setFilteredUsers(prev => {
        // If user is currently filtering, preserve the filter by re-applying keys
        // Simple approach: re-merge by index/name (same shape)
        const byId = new Map(merged.map(x => [ (x.email || x.id_utilisateur_gexonline || '').toString().toLowerCase(), x ]));
        return (prev || []).map(p => {
          const k = (p.email || p.id_utilisateur_gexonline || '').toString().toLowerCase();
          return byId.get(k) || p;
        });
      });
    } catch (e) {
      console.warn("Enrich last-connexion failed:", e);
    }
  })();

  return () => { cancelled = true; };
}, [usersList]);


// Parseur tolérant (moment + normalisations)
const parseDbToMoment = (value) => {
  if (!value) return null;

  // Si c'est déjà un Date
  if (value instanceof Date) {
    const m = moment(value);
    return m.isValid() ? m : null;
  }

  let s = String(value).trim();

  // Normalise espaces / microsecondes -> millisecondes
  // "YYYY-MM-DD HH:mm:ss.SSSSSS" -> "YYYY-MM-DDTHH:mm:ss.SSS"
  let normalized = s.replace(" ", "T").replace(/(\.\d{3})\d+$/, "$1");

  // Essais avec moment en strict
  const formats = [
    "YYYY-MM-DDTHH:mm:ss.SSS",
    "YYYY-MM-DDTHH:mm:ss",
    "YYYY-MM-DD HH:mm:ss.SSSSSS",
    "YYYY-MM-DD HH:mm:ss.SSS",
    "YYYY-MM-DD HH:mm:ss",
    moment.ISO_8601,
  ];

  let m = moment(normalized, formats, true);
  if (m.isValid()) return m;

  // 2e tentative: forcer UTC
  m = moment(normalized + "Z", formats, true);
  if (m.isValid()) return m;

  // 3e tentative: timestamp numérique ?
  const num = Number(s);
  if (!Number.isNaN(num)) {
    // supporte secondes OU millisecondes
    const asMs = num < 1e12 ? num * 1000 : num;
    m = moment(asMs);
    if (m.isValid()) return m;
  }

  // 4e: log et retourne null
  console.warn("[Dernière connexion] Impossible de parser:", { raw: value, normalized });
  return null;
};

// Catégorisation demandée
const getRecencyLabelFromMoment = (m) => {
  if (!m || !m.isValid()) return "";
  const diffDays = moment().diff(m, "days", true);
  if (diffDays < 1) return "moins d'un jour";
  if (diffDays < 7) return "moins d'une semaine";
  if (diffDays < 30) return "moins d'un mois";
  if (diffDays < 182) return "moins de six mois";
  if (diffDays < 365) return "moins d'un an";
  return "plus d'un an";
};


  const { refetch } =useQuery(['UsersList', selectedClient],  () => getUsersByClient(setUserList ,selectedClient) , {
    enabled: !!selectedClient,
    refetchOnWindowFocus: true,
    cacheTime: 1000,
    refetchInactive:true,
    onSuccess: () => {
      // This will be called after successful refetch
      setUserList({});   
    },
  
 });

//  useEffect(() => {
//   if (selectedClient) {
//     refetch();
//   }
//  }, [selectedClient, refetch ]);
  
 useEffect(() => {
  
 const UserByClient = Object.values(users)
  setUsersList(UserByClient)
  setFilteredUsers(UserByClient); 
  
 }, [users , setUsersList , selectedClient]);

 const handleSearchChange = (e) => {
  const value = e.target.value.toLowerCase();
  setSearchText(value);

  if (value.trim() === "") {
    setFilteredUsers(usersList); // Reset to original list if search input is cleared
  } else {
    const filtered = usersList.filter(user => 
      user.nom.toLowerCase().includes(value) ||
      user.prenom.toLowerCase().includes(value) ||
      user.email.toLowerCase().includes(value)
    );
    setFilteredUsers(filtered);
  }
};
 
 

    const onClick = () => {
    setDialogAdd(true);
  };

const openConfirmReset = (rowData) => {
  setTargetUser(rowData);
  setConfirmResetOpen(true);
};

const handleCancelReset = () => {
  setConfirmResetOpen(false);
  setTargetUser(null);
};

const handleConfirmReset = async () => {
  if (!targetUser?.email) return;
  try {
    setSendingReset(true);
    await instance.post('/api/utilisateurs/demande-reset-mot-de-passe', { email: targetUser.email });
    toast.current.show({ severity: 'success', summary: 'Succès', detail: 'Demande envoyée avec succès' });
    setConfirmResetOpen(false);
    setTargetUser(null);
  } catch (e) {
    toast.current.show({ severity: 'error', summary: 'Erreur', detail: "L'envoi de la demande a échoué" });
  } finally {
    setSendingReset(false);}};

  const actionBodyTemplate = (rowData) => {
    
      return (
        <React.Fragment>
          <div className="icon-container">
          <FaTrashAlt
            icon="pi pi-trash"
            title="supprimer l'utilisateur"
            className="p-button-rounded succesBtn icon-spacing text-center"
            // onClick={() =>console.log('rowData.role', rowData.role)}
            onClick={() =>supprimer(rowData)}
            hidden= {rowData.role === "utilisateur" ? true : false}
           
                      />
       
       <FaEnvelope 
            icon="pi pi-Envelope"
            title="envoyer un mail de réinitialisation du mot de passe."
            className="p-button-rounded succesBtn icon-spacing text-center"
            //onClick={() => envoyerMail(rowData)}
            onClick={() => openConfirmReset(rowData)}
           
          />
          </div>

        </React.Fragment>
      );
    };



const supprimer =(rowData)=> { 
 
                  setSelectedUser(rowData.id_utilisateur_gexonline); 
                  setTargetUser(rowData);                
                  setDialogDelete(true);
                  }

   
//  const rowClass = (data) => {
//         return {
//             'p-disabled': data.role === "SUPERADMIN"
//         };
//     };
  return ( 
    <div className="users-container">
      <h3 className="User-title"> Utilisateurs </h3>
      <Toast ref={toast} />
      {(isAdmin || isMember) ? (
        <>
      <div className="search">
      <button
         className="btn-user"
         value="Ajouter un utilisateur"
        onClick={onClick}
       >
         {" "}
         Ajouter un utilisateur{" "}
      </button>
      {/* Search input for filtering */}
      <div className="search-container">
        <InputText
          type="search"
          value={searchText}
          onChange={handleSearchChange}
          placeholder="Chercher..."
          className="search-input"
        />
        <i className="pi pi-search" 
        style={{
          position: 'relative',
          left: '-30px',
          cursor: 'pointer',
          color: '#666',
          fontSize: '1rem',
          transition: 'color 0.3s ease',
        }}
        />
      </div>
      
      </div>
   
      
    <h3 className="User-title"> Liste des utilisateurs </h3>
                       
       {usersList.length >0 ? (
     <DataTable 
     value={filteredUsers} 
     scrollable  
     scrollHeight="400px"  
     tableStyle={{ minWidth: '100%' }} 
    //  rowClassName={rowClass}
    //emptyMessage={ <ProgressSpinner />}
      >
       <Column field="prenom" header ="Prénom" style={{ maxWidth: '12%'}} body={(rowData) => (
          <div className="table-data">
          <span className="mobile-header">Prénom: </span>{rowData.prenom}
          </div>
        )}
       ></Column>
        <Column field="nom" header ="Nom" style={{ maxWidth: '18%' }}body={(rowData) => (
         <div className="table-data">
         <span className="mobile-header">Nom: </span>
         <span className="nom-value">{rowData.nom}</span>
         </div>
    )}></Column>
     
        <Column field="email" header ="Email" style={{ minWidth: '30%' }}
         body={(rowData) => (
          <div className="table-data">
         <span className="mobile-header">Email: </span>{rowData.email}
         </div>
        )}></Column>
         <Column field="role" header ="Rôle" style={{ minWidth: '20%' }}
         body={(rowData) => (
          <div className="table-data">
         <span className="mobile-header">Rôle: </span>{rowData.role}
         </div>
        )}
         ></Column>
       <Column
  header="Dernière connexion"
  style={{ minWidth: '14%' }}
  body={(rowData) => {
    const raw = pickLastLoginRaw(rowData);
    const m = parseDbToMoment(raw);

    // Logs utiles (une seule fois par ligne)
    if (process.env.NODE_ENV !== 'production') {
      console.debug("[Dernière connexion] row id:", rowData.id_utilisateur_gexonline, {
        raw,
        parsed: m ? m.format() : null,
        valid: !!(m && m.isValid()),
      });
    }

    const title = m ? m.format("DD/MM/YYYY HH:mm:ss") : "";
    return (
      <div className="table-data" title={title}>
        <span className="mobile-header">Dernière connexion: </span>
        {getRecencyLabelFromMoment(m)}
      </div>
    );
  }}
/>




      {/* {  isGexMemeber(user) && <Column field="date_octroi_role" header ="date_octroi_role" style={{ width: '20%' }}></Column>}
      {  isGexMemeber(user) &&  <Column field="added_by" header ="Ajouté par" style={{ width: '20%' }}></Column>}
         */}
          <Column  style={{ minWidth: '5%' }}         
           body={actionBodyTemplate}
         
        ></Column>
      </DataTable>):( 
        <span>Aucun utilisateur trouvé </span>
        
      )}
    
       <Dialog
         visible={openDialogAdd}
        style={{ width: "50vw" }}
         onHide={(e) => setDialogAdd(false)}
      >
        <AddUser
          setDialogAdd={setDialogAdd}
          refetch={refetch}
        />
      </Dialog>
       <Dialog
  visible={openDialogDelete}
  style={{ width: "35rem", maxWidth: "90vw" }}
  onHide={() => setDialogDelete(false)}
  header="Confirmer la suppression"
  modal
>
  <DeleteUser
    setDialogDelete={setDialogDelete}
    refetch={refetch}
    user={targetUser}
    client={clientTableau.find(c => c.id_client_gexpertise === selectedClient)}
    openDialogDelete={openDialogDelete}
    deletingUser={deletingUser}
    setDeletingUser={setDeletingUser}
  />
</Dialog>

       {/* Popup de confirmation d'envoi de reset password */}
      <Dialog
        visible={confirmResetOpen}
        style={{ width: "35rem", maxWidth: "90vw" }}
        onHide={handleCancelReset}
        header="Confirmer l’envoi"
        modal
      >
        <div className="p-3">
          <p style={{ lineHeight: 1.5 }}>
            Voulez-vous envoyer une demande de réinitialisation du mot de passe à
            {` `}
            <strong>
              {targetUser ? `${targetUser.prenom} ${targetUser.nom}` : ''} {targetUser ? `[${targetUser.email}]` : ''}
            </strong>
            ?
          </p>
          <div className="flex gap-2 justify-end mt-4">
            <Button
              label="ANNULER"
              className="p-button-text" 
              onClick={handleCancelReset}
              disabled={sendingReset}
            />
            <Button  style={{ backgroundColor: ' #b71c1c', borderColor: ' #b71c1c' }}
              label={sendingReset ? "Envoi..." : "CONFIRMER"}
              onClick={handleConfirmReset}
             disabled={sendingReset}
           />
        </div>
       </div>
      </Dialog>
       </>
    ) : (
      <div className="no-access-message">
        <p>Vous n’avez pas les permissions nécessaires pour afficher cette liste.</p>
      </div>
    )}
  </div>
);
}
